import { render } from "./SpacialistLink.vue?vue&type=template&id=f7b287f2"
import script from "./SpacialistLink.vue?vue&type=script&lang=js"
export * from "./SpacialistLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__